<template>
  <div class="certificate-container">
    <!-- 证书信息表格 -->
    <div class="info-section">
      <h2>证书信息 Certificate Information</h2>
      <div class="flex">
        <table class="info-table">
          <tr>
            <td class="label">姓名</td>
            <td class="value">{{ cert_info.name }}</td>
          </tr>
          <tr>
            <td class="label">性别</td>
            <td class="value">{{ cert_info.sex }}</td>
          </tr>
          <tr>
            <td class="label">国籍</td>
            <td class="value">{{ cert_info.company }}</td>
          </tr>
          <tr>
            <td class="label">证件类型</td>
            <td class="value">{{ cert_info.cert_type }}</td>
          </tr>
          <!--          <tr>
                      <td class="label">证件号码</td>
                      <td class="value">{{ cert_info.cert_no }}</td>
                    </tr>-->
        </table>
        <!-- 网络图片示例（可替换为实际证书图片）-->
        <img :src="cert_info.avatar" alt="证书示例图片" class="certificate-image">
      </div>
      <table class="info-table">
        <tr>
          <td class="label">证件号码</td>
          <td class="value">{{ cert_info.cert_no }}</td>
        </tr>
      </table>
    </div>
    <!-- 考试信息表格 -->
    <div class="info-section">
      <h2>考试信息 Exam Information</h2>
      <table class="info-table">
        <!--    <tr>
            <td class="label">考点名称</td>
            <td class="value">{{ exam_info.address }}</td>
          </tr>
        <tr>
            <td class="label">准考证号</td>
            <td class="value">{{ exam_info.exam_no }}</td>
          </tr>-->
        <tr>
          <td class="label">证书编号</td>
          <td class="value">{{ exam_info.cert_number }}</td>
        </tr>
        <tr>
          <td class="label">证书名称</td>
          <td class="value">{{ exam_info.cert_name }}</td>
        </tr>
        <tr>
          <td class="label">批准日期</td>
          <td class="value">{{ exam_info.cert_date }}</td>
        </tr>
        <tr>
          <td class="label">合格情况</td>
          <td class="value">{{ exam_info.exam_status }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import {searchCert} from "@/api/api";

export default {
  data() {
    return {
      cert_info: {}, //证书信息
      exam_info: {}, //考试信息
    }
  },
  mounted() {
    const cert_no = this.$route.query.cert_no; // 'John'
    this.detail(cert_no)
  },
  methods: {
    detail(e) {
      searchCert({cert_no: e}).then(res => {
        if (res.status === 200) {
          this.cert_info = res.data.cert_info
          this.exam_info = res.data.exam_info
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.certificate-container {
  max-width: 1000px;
  padding: 30px;
  margin: 0 auto;
  background: #fff;
}

.certificate-image {
  width: 300px;
  height: 241px;
  object-fit: cover;
  border: 1px solid #eee;
}

.info-section {
  margin-bottom: 30px;
}

h2 {
  color: #2c3e50;
  border-left: 4px solid #3498db;
  padding-left: 10px;
  margin-bottom: 20px;
}

.info-table {
  width: 100%;
  border-collapse: collapse; //合并单元格
  font-size: 16px;
}

.info-table tr {
  border-bottom: 1px solid #eee;
}

.info-table td {
  padding: 15px 10px;
  vertical-align: top; //垂直居中
}

.label {
  width: 90px;
  color: #666;
  font-weight: 500;
  white-space: nowrap; //不允许换行
}

.value {
  color: #333;
}

@media (max-width: 768px) {
  .certificate-container {
    padding: 15px;
  }
  .certificate-image {
    width: 150px;
    height: 158px;
  }
  .info-table {
    font-size: 14px;
  }

  .info-table td {
    padding: 10px 5px;
  }

  h2 {
    font-size: 18px;
  }
}
</style>
